import React, { useState, useEffect } from 'react';
import { Container, Tab, Nav, Card, Row, Col, Button } from 'react-bootstrap';
import OrderIcon from '@mui/icons-material/ReceiptLong';
import DateRangeIcon from '@mui/icons-material/DateRange';
import StartDateIcon from '@mui/icons-material/EventAvailable';
import RenewalIcon from '@mui/icons-material/Autorenew';
import AssignmentIcon from '@mui/icons-material/Assignment';
import moment from 'moment';
import toast from 'react-hot-toast';

const SUBSCRIPTION_DATA = {
  current: [
    {
      id: '147289',
      orderDateTime: '2024-07-09T11:27:20',
      startDate: '2024-07-09',
      renewalDate: '2025-07-09',
      plan: 'Annually',
    },
  ],
  upcoming: [
    {
      id: '157200',
      orderDateTime: '2024-11-15T09:45:00',
      startDate: '2025-08-15',
      renewalDate: '2025-11-15',
      plan: 'Quarterly',
    },
  ],
  expired: [
    {
      id: '110442',
      orderDateTime: '2023-06-23T13:03:45',
      startDate: '2023-06-23',
      renewalDate: '2024-06-23',
      plan: 'Monthly',
    },
    {
      id: '107899',
      orderDateTime: '2023-03-12T16:12:30',
      startDate: '2023-03-12',
      renewalDate: '2024-03-12',
      plan: 'Monthly',
    },
  ],
};

function AgentPanel() {
  const [plans, setPlans] = useState({ current: [], upcoming: [], expired: [] });

  useEffect(() => {
    setPlans(SUBSCRIPTION_DATA);
  }, []);

  const handleRenewPlan = () => {
    toast.success('Sending renew plan request');
  };

  const renderPlanDetails = (plan) => (
    <Card className="p-3 mb-3" key={plan.id}>
      <Row>
        <Col xs={12} md={4} className="p-2">
          <div className="d-flex align-items-center">
            <OrderIcon sx={{ fontSize: '25px' }} className="me-2 base-color" />
            <div>
              <p className="mb-0 text-dark fw-400 fs-14">Order ID</p>
              <span className="fs-16 fw-bold text-dark">#{plan.id}</span>
            </div>
          </div>
        </Col>
        <Col xs={12} md={4} className="p-2">
          <div className="d-flex align-items-center">
            <DateRangeIcon sx={{ fontSize: '25px' }} className="me-2 base-color" />
            <div>
              <p className="mb-0 text-dark fw-400 fs-14">Order Date & Time</p>
              <span className="fs-16 fw-bold text-dark">{moment(plan.orderDateTime).format('DD-MMM-YYYY HH:mm')}</span>
            </div>
          </div>
        </Col>
        <Col xs={12} md={4} className="p-2">
          <div className="d-flex align-items-center">
            <StartDateIcon sx={{ fontSize: '25px' }} className="me-2 base-color" />
            <div>
              <p className="mb-0 text-dark fw-400 fs-14">Start Date</p>
              <span className="fs-16 fw-bold text-dark">{moment(plan.startDate).format('DD-MMM-YYYY')}</span>
            </div>
          </div>
        </Col>

        <Col xs={12} md={4} className="p-2">
          <div className="d-flex align-items-center">
            <RenewalIcon sx={{ fontSize: '25px' }} className="me-2 base-color" />
            <div>
              <p className="mb-0 text-dark fw-400 fs-14">Renewal Date</p>
              <span className="fs-16 fw-bold text-dark">{moment(plan.renewalDate).format('DD-MMM-YYYY')}</span>
            </div>
          </div>
        </Col>
        <Col xs={12} md={4} className="p-2">
          <div className="d-flex align-items-center">
            <AssignmentIcon sx={{ fontSize: '25px' }} className="me-2 base-color" />
            <div>
              <p className="mb-0 text-dark fw-400 fs-14">Plan</p>
              <span className="fs-16 fw-bold text-dark">{plan.plan}</span>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );

  return (
    <Container fluid className="px-0">
      <div className="bg-white p-4 min-vh-100 shadow-sm">
        <div className="d-flex justify-content-between mb-2">
          <h3 className="base-color">Subscription Details</h3>
          <Button className="login-btn base-color-bg text-white px-4" onClick={handleRenewPlan}>
            Renew Plan
          </Button>
        </div>

        <Tab.Container defaultActiveKey="Active">
          <Nav variant="tabs" className="my-subscription-nav border-0">
            <Nav.Item className="current-active-plan">
              <Nav.Link eventKey="Active" as="button" className="fs-16 text-dark">
                Current Plan
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="upcoming-active-plan">
              <Nav.Link eventKey="Upcoming" as="button" className="fs-16 text-dark">
                Upcoming Plan
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="expired-active-plan">
              <Nav.Link eventKey="Expire" as="button" className="fs-16 text-dark">
                Expired Plan
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="mt-4">
            <Tab.Pane eventKey="Active">
              {plans.current.length ? (
                plans.current.map(renderPlanDetails)
              ) : (
                <Card className="text-center p-3">
                  <h4 className="text-capitalize mt-3 mb-0">No current plan</h4>
                </Card>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="Upcoming">
              {plans.upcoming.length ? (
                plans.upcoming.map(renderPlanDetails)
              ) : (
                <Card className="text-center p-3">
                  <h4 className="text-capitalize mt-3 mb-0">No upcoming plan</h4>
                </Card>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="Expire">
              {plans.expired.length ? (
                plans.expired.map(renderPlanDetails)
              ) : (
                <Card className="text-center p-3">
                  <h4 className="text-capitalize mt-3 mb-0">No expired plan</h4>
                </Card>
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </Container>
  );
}

export default AgentPanel;
